import { serviceName } from '../resources/serviceConstants';
import { MILESTONE } from '../resources/endPoint';

const buildRequest = (url, method = 'get', payload) => ({
  url,
  method,
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload !== undefined ? { payload } : {}),
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

/* ------------------------------------------------------------------ */
/*  Dropdown / filter options                                          */
/* ------------------------------------------------------------------ */

export const getMilestoneDropdownOptions = (optionType) =>
  buildRequest(`${MILESTONE}/options/${optionType}`);

/* ------------------------------------------------------------------ */
/*  Project-scoped reads                                               */
/* ------------------------------------------------------------------ */

export const getMilestonePoNumbers = (projectId) =>
  buildRequest(`${MILESTONE}/projects/${projectId}/po-numbers`);

export const searchPoNumbers = (term) =>
  buildRequest(`${MILESTONE}/po-numbers/search?q=${encodeURIComponent(term)}`);

export const getZohoInvoices = (projectId) =>
  buildRequest(`${MILESTONE}/projects/${projectId}/zoho-invoices`);

export const getProjectInvoices = (projectId) =>
  buildRequest(`${MILESTONE}/projects/${projectId}/invoices`);

/* ------------------------------------------------------------------ */
/*  Milestone CRUD                                                     */
/* ------------------------------------------------------------------ */

export const getSingleMilestone = (milestoneId) =>
  buildRequest(`${MILESTONE}/${milestoneId}`);

export const createMilestone = (payload) =>
  buildRequest(`${MILESTONE}`, 'post', payload);

export const updateMilestone = (milestoneId, payload) =>
  buildRequest(`${MILESTONE}/${milestoneId}`, 'put', payload);

/* ------------------------------------------------------------------ */
/*  Invoice CRUD                                                       */
/* ------------------------------------------------------------------ */

export const getSingleInvoice = (invoiceId) =>
  buildRequest(`${MILESTONE}/invoices/${invoiceId}`);

export const createInvoice = (milestoneId, payload) =>
  buildRequest(`${MILESTONE}/${milestoneId}/invoices`, 'post', payload);

export const updateInvoice = (invoiceId, payload) =>
  buildRequest(`${MILESTONE}/invoices/${invoiceId}`, 'put', payload);

/* ------------------------------------------------------------------ */
/*  Collection CRUD                                                    */
/* ------------------------------------------------------------------ */

export const getSingleCollection = (collectionId) =>
  buildRequest(`${MILESTONE}/collections/${collectionId}`);

export const createCollection = (invoiceId, payload) =>
  buildRequest(`${MILESTONE}/invoices/${invoiceId}/collections`, 'post', payload);

export const updateCollection = (collectionId, payload) =>
  buildRequest(`${MILESTONE}/collections/${collectionId}`, 'put', payload);
